module.exports = __webpack_public_path__ + "src/img/smartEditOn.8fa10eca.svg";